import { Link } from "react-router-dom";
import style from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={style.footer}>
        <div className={style.footerLogo}>
            <Link to="/">
              <span className={style.footerIcon} aria-label="OKboard" />
            </Link>    
            <p className={style.logoText}>by EdEra</p>
        </div>
        <div className={style.footerText}>
        &#169; 2014-{new Date().getFullYear()} Educational era
        </div>
    </footer>
  );
};

export default Footer;
